{
  "seo": {
    "notFoundTitle": "Question not found",
    "loadingTitle": "Loading question...",
    "description": "{shortAnswer} — Learn more about {category} on CuriPop.",
    "fallbackDescription": "Discover fun answers to kids' biggest questions on CuriPop.",
    "keywords": "{question}, {category}, kids questions, fun facts, {tags}",
    "homeLabel": "Home"
  },
  "status": {
    "loading": "Loading question...",
    "forbidden": "This question is part of the Family plan.",
    "notFound": "We couldn't find that question.",
    "error": "We couldn't load this question right now."
  },
  "actions": {
    "seePlans": "See plans",
    "backToExplore": "Back to Explore",
    "backToPath": "Back to Learning Path",
    "tryAgain": "Try again",
    "like": "Like question",
    "unlike": "Unlike question",
    "saveQuestion": "Save question",
    "removeBookmark": "Remove bookmark",
    "stopSpeaking": "Stop speaking",
    "readAloud": "Read aloud",
    "prevFact": "Previous fact",
    "nextFact": "Next fact",
    "factIndex": "Go to fact {index}"
  },
  "pathNext": {
    "continueTitle": "Nice work!",
    "continueSubtitle": "Ready for the next step?",
    "continueCta": "Continue",
    "lastStepTitle": "You finished this step!",
    "lastStepSubtitle": "Head back to your learning path to see what's next.",
    "lastStepCta": "Back to Learning Path"
  },
  "sections": {
    "quickAnswer": "Quick Answer",
    "deepDive": "Deep Dive",
    "submittedBy": "Submitted by a curious mind: {name}",
    "funFacts": "Fun Facts",
    "moreToExplore": "More To Explore"
  },
  "readingLevel": {
    "lexile": "Lexile {level}",
    "auto": "Auto: Lexile {level}"
  }
}
